import { render, staticRenderFns } from "./untreadList.vue?vue&type=template&id=ab820bd0&scoped=true&"
import script from "./untreadList.vue?vue&type=script&lang=js&"
export * from "./untreadList.vue?vue&type=script&lang=js&"
import style0 from "./untreadList.vue?vue&type=style&index=0&id=ab820bd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab820bd0",
  null
  
)

export default component.exports